var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMidtargetactiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.2466,
    cy: 14.0083,
    r: 1.60205,
    fill: "#623CE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5192 6.80669L15.9898 11.3363C15.7105 11.6155 15.3549 11.8058 14.9678 11.8832L12.8783 12.3011L13.2962 10.2116C13.3736 9.82446 13.5639 9.46887 13.8431 9.18967L18.3726 4.66008M20.5192 6.80669L21.648 5.67793C22.0385 5.28741 22.0385 4.65424 21.648 4.26372L20.9156 3.53133C20.5251 3.1408 19.8919 3.1408 19.5014 3.53133L18.3726 4.66008M20.5192 6.80669L18.3726 4.66008",
    stroke: "#623CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0423 13.2303C20.0423 14.8895 19.5902 17.3788 18.6119 18.7584C17.6336 20.138 16.3376 21.2731 14.7108 21.9081C13.0839 22.5431 11.1387 22.8746 9.4117 22.5509C7.68466 22.2272 6.0136 21.1414 4.76847 19.9681C3.52335 18.7948 2.67541 17.3 2.33188 15.6726C1.98835 14.0452 2.13839 11.8064 2.81225 10.2734C3.48611 8.74044 4.89168 7.14554 6.35579 6.2237C7.8199 5.30187 9.99133 5.002 11.7522 5.002",
    stroke: "#623CE7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9332 13.6431C16.9332 14.6962 16.6146 15.7257 16.0176 16.6013C15.4206 17.477 14.572 18.1594 13.5792 18.5625C12.5865 18.9655 11.494 19.0709 10.4401 18.8655C9.38617 18.66 8.41807 18.1529 7.65823 17.4082C6.89839 16.6635 6.38093 15.7148 6.17129 14.6819C5.96165 13.649 6.06925 12.5784 6.48047 11.6054C6.89169 10.6324 7.58808 9.80082 8.48155 9.21573C9.37503 8.63065 10.4255 8.31836 11.5001 8.31836",
    stroke: "#623CE7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidtargetactiveIcon);
export default __webpack_public_path__ + "static/media/midtargetactiveIcon.76698adeb72c63c340c757478dc172a3.svg";
export { ForwardRef as ReactComponent };